import React from 'react'
import Page from '../Page';
import {ProgressBar} from "react-step-progress-bar";
import Modal from "../../components/Modal";
import ReferralModal from "../talent/ReferralModal";

export default class TalentUnderReview extends Page {

    static path = '/talent/under-review';

    constructor(props) {
        super(props);
        this.referralFormModal = React.createRef();
        this.referralForm = React.createRef();

        this.state = {
            ...this.state,
            isDisabled: false,
        };
    }

    showReferralModal()
    {
        return this.referralFormModal.current?.showModal()
    }

    render() {
        let user = this.context?.auth
        if (!user) {
            return <div/>;
        }

        return (
            <div className="talent-application-container review-application">
                <div className="talent-application-progress">
                    <ProgressBar
                        filledBackground={TB.config('color.light_green')}
                        height={30}
                        percent={100}
                        unfilledBackground={TB.config('color.backgroundGray')}/>
                    <p className="talent-app-progress-title" style={{right: 0}}>
                        {TB.trans('talent.under_review.talent_app_progress_title')}
                    </p>
                </div>
                <div className="talent-application-form-container">
                    <div className="talent-application">
                        <div className="under-review-panel">

                            <h3>
                                {TB.trans('talent.under_review.under_review_panel_h3_beg')}&nbsp;
                                {user.first_name}! {TB.trans('talent.under_review.under_review_panel_h3_end')}
                            </h3>

                            <p>
                                {TB.trans('talent.under_review.under_review_panel_p')}
                            </p>

                            <button
                                disabled={this.state.isDisabled}
                                onClick={this.showReferralModal.bind(this)}
                                className="btn btn-outline-dark">
                                {TB.trans('talent.under_review.buttons.refer')}
                            </button>

                            <button className="exit-btn btn btn-link"
                                    disabled={this.state.isDisabled}
                                    onClick={async() => {
                                        await this.promisedState({isDisabled: true})
                                        return TB.auth().logout();
                                    }}>
                                {TB.trans('talent.under_review.buttons.exit')}
                            </button>
                        </div>
                    </div>
                </div>

                <Modal
                    ref={this.referralFormModal}
                    modalClass='referral-modal-form'
                    onCloseAction={async() => {
                        await TB.wait(400);
                        return this.referralForm.current?.resetForm();
                    }}>
                    <ReferralModal
                        ref={this.referralForm}
                        onToggleDisabled={isDisabled => this.promisedState({isDisabled})}
                        isDisabled={this.state.isDisabled}/>
                </Modal>
            </div>
        );
    }
}
